import { useMemo } from 'react'
import i18n from '../../../i18n'
import { CategoryData } from '../types/categoryData'
import { BadgeHook } from './useBadges'

interface BadgeSwiperDataHookProps {
	badgeHook: BadgeHook
}

const useBadgeSwiperData = ({ badgeHook }: BadgeSwiperDataHookProps) => {
	return useMemo(() => {
		const badges = badgeHook.badges
		const userBadges = badgeHook.userBadges

		const categories: Record<string, CategoryData> = {}

		badges?.forEach(badge => {
			if (!categories[badge.category]) {
				categories[badge.category] = {
					tiers: [],
					categoryName: i18n.language === 'en' ? badge.nameEn : badge.nameFi,
				}
			}

			badge.tiers.forEach(tier => {
				const userBadge = userBadges?.find(ub => ub.badgeId === badge.id && ub.tierId === tier.id)

				categories[badge.category].tiers.push({
					badge,
					tier,
					isCompleted: !!userBadge,
					userBadge: userBadge || undefined,
				})
			})
		})

		Object.values(categories).forEach(categoryData => {
			categoryData.tiers = categoryData.tiers
				.filter(tierData => tierData.tier.tierLevel > 0)
				.sort((a, b) => a.tier.tierLevel - b.tier.tierLevel)
		})

		return categories
	}, [badgeHook.badges, badgeHook.userBadges])
}

export default useBadgeSwiperData
